import { extend } from "jquery";
import React from "react";
import maatregelenSvg from "../../../../content/images/table/XMLID_3_.svg";
import $ from "jquery";
import * as GC from "../../../common/common";
import ColumnList from "../../../common/componet-jsons/column-list-catalog.json";
import * as omnimap from "../../../../api/omnimap/omnimapActions";
import * as CallBackFunctions from "./functions/callBackFunctions";
import * as CommonFunctions from "./functions/commonFunctions";
import { CONSTS } from "../../../common/const";

import "./variable/v";
class Table extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      columnList: [],
      columnListPure: [],
      columnOrderIdentification: "",
      columnOrderReference: "",
    };
  }
  //** fill row of table.
  async fillTable(model, page_number) {
    var that = this;
    window.$catalog_planning_period_scroll_change = false;

    let result = await omnimap.FillTableAction(
      model,
      page_number,
      window.$catalog_management_units_token
    );

    CallBackFunctions.FillTableCallBack(
      result,
      page_number,
      window.$catalog_planning_columnListPure
    );
  }

  //** tabloyu yeni̇leyen fonksi̇yon
  reloadData(page_number, ids, short_type, direction, field, active = []) {
    var model;
    if (!short_type) {
      if (ids && ids.length) {
        model = {
          content: [
            {
              key: "algemeen-actief",
              and_or: "AND",
              values: active,
              datatype: "BOOLEAN",
            },
          ],
          context: [
            {
              role: "Werkplan zit in folder",
              instance_identifiers: ids,
              direction: "from",
              and_or: "AND",
              start: "2020-11-09T09:56:22.986Z",
            },
          ],
          sorting: [],
          definitions: [process.env.REACT_APP_PLANNINGSPERIODEN],
        };
      } else {
        model = {
          content: [
            {
              key: "algemeen-actief",
              and_or: "AND",
              values: active,
              datatype: "BOOLEAN",
            },
          ],
          definitions: [process.env.REACT_APP_PLANNINGSPERIODEN],
          sorting: [],
        };
      }
    } else if (short_type) {
      if (ids && ids.length) {
        model = {
          content: [
            {
              key: "algemeen-actief",
              and_or: "AND",
              values: active,
              datatype: "BOOLEAN",
            },
          ],
          context: [
            {
              role: "Werkplan zit in folder",
              instance_identifiers: ids,
              direction: "from",
              and_or: "AND",
              start: "2020-11-09T09:56:22.986Z",
            },
          ],
          sorting: [
            {
              sort_type: short_type,
              direction: direction,
              field: field,
            },
          ],
          definitions: [process.env.REACT_APP_PLANNINGSPERIODEN],
        };
      } else {
        model = {
          content: [
            {
              key: "algemeen-actief",
              and_or: "AND",
              values: active,
              datatype: "BOOLEAN",
            },
          ],
          definitions: [process.env.REACT_APP_PLANNINGSPERIODEN],
          sorting: [
            {
              sort_type: short_type,
              direction: direction,
              field: field,
            },
          ],
        };
      }
    }

    window.$catalog_planning_period_lastUsedTableFilter = model;
    this.fillTable(model, page_number);
    this.fillFilterColumns();
  }

  addContentAndFillTable(key, value) {
    var hasRow = $.grep(window.$catalog_planning_period_content, function (v) {
      return v.key === key;
    });
    if (hasRow.length > 0) {
      window.$catalog_planning_period_content = $.grep(
        window.$catalog_planning_period_content,
        function (value) {
          return value !== hasRow[0];
        }
      );
    }
    if (value !== null) {
      var values = [];
      values.push(value);
      var contentModel = {
        and_or: "AND",
        datatype: "STRING",
        key: key,
        values: values,
      };
      window.$catalog_planning_period_content.push(contentModel);
    }

    var model = {
      content: window.$catalog_planning_period_content,
      definitions: [process.env.REACT_APP_PLANNINGSPERIODEN],
    };

    window.$catalog_planning_period_lastUsedTableFilter = model;
    this.fillTable(model, 1);
  }

  //** fill search input
  fillFilterColumns(key) {
    var that = this;
    var model = {
      definitions: [process.env.REACT_APP_PLANNINGSPERIODEN],
    };
    $.each(this.columnList, async function (index, data) {
      if (data.id !== "" && data.filter === true) {
        let result = await omnimap
          .FillFilterColumnsAction(
            model,
            data.id,
            window.$catalog_management_units_token
          )
          .catch((error) => {
            console.log(error);
          });

        CallBackFunctions.FillFilterColumnsCallBack(data, result);
      }
    });
  }
  //** server-side search rows for table attribute
  async searchFilterColumns(key, searchId) {
    var that = this;
    var model = {
      definitions: [process.env.REACT_APP_PLANNINGSPERIODEN],
    };

    let result = await omnimap
      .SearchFilterColumnsAction(
        model,
        key,
        searchId,
        window.$catalog_management_units_token
      )
      .catch((error) => {
        console.log(error);
      });
    CallBackFunctions.SearchFilterColumnsCallBack(searchId, result);
  }

  //** fecth tree node all ids when click tree node
  treeParser = (data, beheereenheid) => {
    const that = this;
    data.forEach(function (element) {
      if (element.parentfolder === beheereenheid) {
        window.$catalog_planning_period_result.push(element.id);
        if (element.children.length > 0) {
          that.treeParser(element.children, element.id);
        }
      } else if (element.children && element.children.length > 0) {
        that.treeParser(element.children, beheereenheid);
      }
    });
  };

  componentWillUnmount() {}

  componentDidUpdate(prevProps, prevState) {
    const that = this;
    if (!that.props.location.state) {
      if (that.props.location.isDidUpdate !== prevProps.location.isDidUpdate) {
        var model = {
          content: [],
          definitions: [process.env.REACT_APP_PLANNINGSPERIODEN],
        };
        // that.setState({ lastUsedTableFilter: model });
        that.reloadData(1);
        document.getElementById("tree-parent-id").setAttribute("value", "");

        var treeClass = document.querySelector(".tree li.open.act");
        var treeDivClass = document.querySelector(".tree li div.open.act");
        if (treeClass !== null) {
          treeClass.removeAttribute("class");
        }
        if (treeDivClass !== null) {
          treeDivClass.classList.remove("open");
          treeDivClass.classList.remove("act");
        }
      } else {
        $("#cover-spin").hide(0);
      }
    } else if (that.props.location.state && prevProps.location.state) {
      if (
        that.props.location.state.isDidUpdate !==
        prevProps.location.state.isDidUpdate
      ) {
        if (that.props.location.state.isDidUpdate == "0038") {
          var model = {
            content: [],
            definitions: [process.env.REACT_APP_PLANNINGSPERIODEN],
          };
          // that.setState({ lastUsedTableFilter: model });
          that.reloadData(1);
        } else {
          window.$catalog_planning_period_result = [];
          window.$catalog_planning_period_result.push(
            that.props.location.state.id
          );
          this.treeParser(
            that.props.location.state.TreeList,
            that.props.location.state.id
          );
          if (that.props.location.state.treeLocation !== "modal") {
            that.reloadData(1, window.$catalog_planning_period_result);
          }
        }
      }
      //* sayfa f5 ile yenilendiğinde prev props:
      //* temizlenmediğinden dolayı veri gelmemesi sorunu için bu kod çalıştırılıyor.
      else if (window.performance) {
        if (performance.navigation.type == 1) {
          if (that.props.location.state.isDidUpdate == "0038") {
            var model = {
              content: [],
              definitions: [process.env.REACT_APP_PLANNINGSPERIODEN],
            };
            // that.setState({ lastUsedTableFilter: model });
            that.reloadData(1);
          } else {
            window.$catalog_planning_period_result = [];
            window.$catalog_planning_period_result.push(
              that.props.location.state.id
            );
            this.treeParser(
              that.props.location.state.TreeList,
              that.props.location.state.id
            );
            if (that.props.location.state.treeLocation !== "modal") {
              that.reloadData(1, window.$catalog_planning_period_result);
            }
          }
        } else {
          alert("This page is not reloaded");
        }
      }
    } else {
      window.$catalog_planning_period_result = [];
      window.$catalog_planning_period_result.push(that.props.location.state.id);
      this.treeParser(
        that.props.location.state.TreeList,
        that.props.location.state.id
      );
      if (that.props.location.state.treeLocation !== "modal") {
        that.reloadData(1, window.$catalog_planning_period_result);
      }
      $("#cover-spin").hide(0);
    }
  }

  async componentDidMount() {
    var that = this;

    /***************************************************************************************/
    /**FREE FORMAT */
    var tableHeaderItems;
    var userColumnResult = await omnimap.GetFreeFormatByIdAction(
      CONSTS.USER_ID_STORE
    );
    // userda column sort id'si varmı ?
    if (userColumnResult.meta.total_found == 0) {
      var user = window.localStorage.getItem("accessToken");
      window.$mm_management_units_column_order_users.client_identification =
        CONSTS.USER_ID_STORE;
      window.$mm_management_units_column_order_users.code =
        CONSTS.USER_ID_STORE;
      window.$mm_management_units_column_order_users.data.users.push({
        user_id: user.identification,
        id_stores: {
          table_column_order: GC.uuidv4(),
        },
      });
      omnimap
        .GetFreeFormatAction(
          "",
          "POST",
          window.$mm_management_units_column_order_users
        )
        .then(() => {
          // GC.sleep(1500).then(() => this.fillTable());
        });
    }
    //userda column sort id'si var sa else geç
    else {
      let result = await omnimap.GetFreeFormatByIdAction(
        CONSTS.COLUMN_ORDER_CATALOG_PLANNING_PERIOD
      );

      // bu sayfanın column sort'u var mı?
      if (result.meta.total_found == 0) {
        window.$catalog_planning_period_column_order_post_model.client_identification =
          CONSTS.COLUMN_ORDER_CATALOG_PLANNING_PERIOD;
        window.$catalog_planning_period_column_order_post_model.code =
          CONSTS.COLUMN_ORDER_CATALOG_PLANNING_PERIOD;

        omnimap
          .GetFreeFormatAction(
            "",
            "POST",
            window.$catalog_planning_period_column_order_post_model
          )
          .then(() => {
            window.location.reload();
          });
      }
      // bu sayfanın column sort'u varsa else'e geç
      else {
        //burada sayfanın column sortları listenelinr ve table th sıralaması yapılır

        let result = await omnimap.GetFreeFormatByIdAction(
          CONSTS.COLUMN_ORDER_CATALOG_PLANNING_PERIOD,
          "GET"
        );

        await this.setState({
          columnOrderIdentification: result.data[0].identification,
          columnOrderReference: result.data[0].reference,
        });

        result = await result.data[0].data.table_sorting.find(
          (x) => x.name === "catalog>planning-period"
        );

        tableHeaderItems = await result.column_list.map((item, index) =>
          item === "checkbox" ? (
            <th className="sorting_disabled">
              <span className="checkAll" />
              <span className="checkNone" style={{ display: "none" }} />
            </th>
          ) : item === "active" ? (
            <th className="sorting_disabled" style={{ width: "1%" }}>
              <div id="beheer-short-table">
                <div id="beheer-svg" className="maatregelen-svg"></div>
                <div id="beheer-snowflake" className="snowflake"></div>
              </div>
            </th>
          ) : (
            <th key={item}>{item}</th>
          )
        );
        await this.setState({
          columnList: tableHeaderItems,
        });
        window.$catalog_planning_columnListPure = result;
      }
    }
    /***************************************************************************************/

    ColumnList.forEach(function (item) {
      if (item.name == "catalog>planning-period") {
        window.$catalog_planning_period_column_list = item["column-list"];
      }
    });

    if (window.$catalog_management_units_token == null) {
      window.$catalog_management_units_token = GC.GetToken().then((token) => {
        window.$catalog_management_units_token = token;
        this.reloadData(1);
      });
    } else that.reloadData(1);

    var table = $("#example").DataTable({
      order: [],
      ordering: false,
      orderCellsTop: true,
      fixedHeader: true,
      searching: false,
      paging: false,
      scrollX: true, //"500px",

      scrollCollapse: true,
      scrollY: "calc(100vh - 330px)",

      dom: '<"top"if>t<"bottom"pr><"clear">',
      info: true,
      infoCallback: function (settings, start, end, max, total, pre) {
        return (
          '<span class="select-item"></span>' +
          '<span class="total_right"><span id="total-rows" class="total">' +
          end +
          "</span> geselecteerd </span>"
        );
      },
      language: {
        paginate: {
          previous: "Eerste",
          next: "Laatste",
        },
        select: {
          rows: '<span class="items">%d </span>items van&nbsp;', //'<span class="items">%d </span>items van&nbsp;',
        },
      },
      columnDefs: [
        {
          targets: 0,
          data: null,
          defaultContent: "",
          orderable: false,
          className: "select-checkbox",
        },
      ],
      select: {
        style: "multi+shift",
        selector: "tr",
      },
      // Disable sorting on the sorting_disabled class
      aoColumnDefs: [
        {
          bSortable: false,
          aTargets: ["sorting_disabled"],
        },
      ],
      colReorder: {
        fixedColumnsLeft: 1
      },
      stateSave: true,
      stateSaveCallback: (settings, data) => {
        let result = CallBackFunctions.TableColumnChangeHandler(
          settings,
          data,
          that.state.columnOrderIdentification,
          that.state.columnOrderReference,
          CONSTS.COLUMN_ORDER_CATALOG_PLANNING_PERIOD
        );
        window.$catalog_planning_columnListPure = result;
      },
    });
    var lastScrollLeft = 0;
    var lastScrollControl = 0.33;
    var buffer = 0.33; // # of pixels from bottom of scroll to fire your function. Can be 0
    $(".dataTables_scrollBody").scroll(function () {
      var documentScrollLeft = $(".dataTables_scrollBody").scrollLeft();
      if (window.$catalog_management_units_scroll_change) {
        if (
          $(".dataTables_scrollBody").prop("scrollHeight") -
            $(".dataTables_scrollBody").scrollTop() <=
          $(".dataTables_scrollBody").height() + buffer
        ) {
          lastScrollControl = 0;
        }
      }
      if (lastScrollLeft == documentScrollLeft + lastScrollControl) {
        if (window.$catalog_planning_period_scroll_change) {
          if (
            $(".dataTables_scrollBody").prop("scrollHeight") -
              $(".dataTables_scrollBody").scrollTop() <=
            $(".dataTables_scrollBody").height() + buffer
          ) {
            if (document.getElementById("tableSide").className !== "d-none") {
              if (
                `/${this.baseURI.split("/")[3]}/${
                  this.baseURI.split("/")[4]
                }` === that.props.location.pathname &&
                window.$catalog_planning_period_table_total_row_count >
                  process.env.REACT_APP_TABLE_TOTAL_ROW_COUNT
              ) {
                $("#cover-spin").show(0);
                window.$catalog_planning_period_page_number++;
                that.fillTable(
                  window.$catalog_planning_period_lastUsedTableFilter,
                  window.$catalog_planning_period_page_number
                );
              }
            } else window.$catalog_planning_period_scroll_change = true;
          }
        }
      }
    });

    $("#example thead tr").clone(true).appendTo("#example thead");

    $(table.table().header()).addClass("scrollabe-datatable");

    var tes = (document.getElementsByClassName(
      "scrollabe-datatable"
    )[0].parentElement.id = "scrollabe-datatable-id");

    $("#scrollabe-datatable-id thead tr")
      .clone(true)
      .appendTo("#scrollabe-datatable-id thead");

    $("#scrollabe-datatable-id thead tr:eq(1) th").each(function (i) {
      var title = $(this).text();
      if (title) {
        var row = $.grep(
          window.$catalog_planning_period_column_list,
          function (v) {
            return String(v.name).toLowerCase() === String(title).toLowerCase();
          }
        );
        var rowId = row[0].id;
        if (row[0].filter == true) {
          $(this).html(
            '<input type="search" class="col-search" id="' + rowId + '" />'
          );
          $("input", this).on("keyup change", function () {
            if (table.column(i).search() !== this.value) {
              table.column(i).search(this.value).draw();
            }
          });
        } else {
          $(this).html("");
        }
      } else if (this.innerHTML.includes("checkAll")) {
        //$(this).html( '<div class="popup threedots" onclick="Popup()"><span class="popuptext" id="myPopup"><a class="maatregelen" href="#">Maatregelen</a><a class="locate" href="#">Beheer gebieden</a><a class="map" href="#">Toon op kaart</a><a class="trash-bin" href="#">Verwijderen</a></span></div>' );
        $(this).html(
          '<div class="popup threedots"><span class="popuptext" id="myPopup"></span></div>'
        );
      } else if (this.innerHTML.includes("snowflake")) {
        $(this).html(
          '<div class="refresh"> </div>' +
            /**popup filter1 */
            '<div class="filter-popup">' +
            '  <span class="popuptext" id="beheer-short-table-popup" ></span>' +
            "</div>"
        );
      } else {
        $(this).html("");
      }
    });
    $("#scrollabe-datatable-id thead").on("click", "th", function () {
      var row_index = table.column(this).index();
      if (row_index != undefined && row_index != 0) {
        var nRow = $("#scrollabe-datatable-id thead tr")[0];

        if (
          this.childNodes[0].className != "popup threedots" &&
          this.childNodes[0].className != "refresh"
        ) {
          nRow.childNodes.forEach(function (indx) {
            if (indx.cellIndex != row_index) {
              indx.className = "sorting_disabled";
            }
          });

          if (this.className == "sorting_disabled") {
            this.className = "sorting_asc";
            var row;
            $.each(
              window.$catalog_planning_period_column_list,
              function (index, data) {
                if (data.row == row_index) {
                  row = data;
                }
              }
            );
            that.reloadData(
              1,
              window.$catalog_planning_period_result,
              row.shortType,
              "ASCENDING",
              row.shortField
            );
          } else if (this.className == "sorting_asc") {
            this.className = "sorting_desc";
            var row;
            $.each(
              window.$catalog_planning_period_column_list,
              function (index, data) {
                if (data.row == row_index) {
                  row = data;
                }
              }
            );
            that.reloadData(
              1,
              window.$catalog_planning_period_result,
              row.shortType,
              "DESCENDING",
              row.shortField
            );
          } else if (this.className == "sorting_desc") {
            this.className = "sorting_asc";
            var row;
            $.each(
              window.$catalog_planning_period_column_list,
              function (index, data) {
                if (data.row == row_index) {
                  row = data;
                }
              }
            );
            that.reloadData(
              1,
              window.$catalog_planning_period_result,
              row.shortType,
              "ASCENDING",
              row.shortField
            );
          }

          window.$catalog_planning_period_page_number = 1;
        }
      }
    });

    $("#example tbody").on("click", "tr", function () {
      if ($(".checkAll").attr("style") == "display: none;") {
        $(".checkNone, .checkAll").toggle();
      }
    });

    //** select all table
    $("#scrollabe-datatable-id").on("click", ".checkAll", function (e) {
      var table = $("#example").DataTable();
      table.rows().select();

      $(".checkNone, .checkAll").toggle();
    });

    //** unselect all table
    $("#scrollabe-datatable-id").on("click", ".checkNone", function (e) {
      var table = $("#example").DataTable();

      table.rows().deselect();
      $(".checkNone, .checkAll").toggle();
    });

    $("#example_filter input").addClass("search-input-table1");
    $(".search-input-table1").attr("placeholder", "search text");
    $("#example tbody").on("dblclick", "tr", function () {
      // var rowId = this.attributes[1].value;
      var rowId = $(this).attr("rowId");

      $.each(window.$catalog_planning_period_Glist, function (index, data) {
        if (data.identification == rowId) {
          window.$catalog_planning_period_selectedRow = data;
        }
      });

      CommonFunctions.fillDetail();
      $("#tableSide").addClass("d-none");
      $("#detailSide").removeClass("d-none");
    });
    // Option to allow selecting rows by clicking on row besides checkbox.
    // $("#example tbody").on("click", "tr", function () {
    //   $(this).toggleClass("selected");
    // });
    $(".col-search").on("input", function (e) {
      if (this.value === "") {
        that.addContentAndFillTable($(this).attr("id"), null);
      }
    });
    table.columns().iterator("column", function (ctx, idx) {
      if (
        window.$catalog_planning_columnListPure.column_list[idx] ===
          "checkbox" ||
        window.$catalog_planning_columnListPure.column_list[idx] === "active"
      ) {
      } else {
        $(table.column(idx).header()).append('<span class="sort-icon"/>');
      }
    });
    $(document).on("click", ".work-plans-catalog-action", function () {
      var actionId = $(this).attr("id");
      let modalId = window.$catalog_planning_period_actions.filter(
        (act) => act["id"] === actionId
      )[0]["modal"];
      $("#" + modalId).modal("show");
    });

    //#region Autocomplete Functions
    $("#algemeen-naam").autocomplete({
      source: window.$catalog_planning_period_algemeenNaam,
      select: function (event, ui) {
        that.addContentAndFillTable("algemeen-naam", ui.item.value);
      },
      open: function (e, ui) {
        $(".ui-autocomplete").css(
          "top",
          $("ul.ui-autocomplete").cssUnit("top")[0] + 2
        );
      },
    });
    $("#algemeen-code").autocomplete({
      source: window.$catalog_planning_period_algemeenCode,
      select: function (event, ui) {
        that.addContentAndFillTable("algemeen-code", ui.item.value);
      },
      open: function (e, ui) {
        $(".ui-autocomplete").css(
          "top",
          $("ul.ui-autocomplete").cssUnit("top")[0] + 2
        );
      },
    });
    $("#algemeen-status").autocomplete({
      source: window.$catalog_planning_period_algemeenFrequentie,
      select: function (event, ui) {
        that.addContentAndFillTable("algemeen-status", ui.item.value);
      },
      open: function (e, ui) {
        $(".ui-autocomplete").css(
          "top",
          $("ul.ui-autocomplete").cssUnit("top")[0] + 2
        );
      },
    });

    $("#algemeen-omschrijving").autocomplete({
      source: window.$catalog_planning_period_algemeenOmschrijving,
      select: function (event, ui) {
        that.addContentAndFillTable("algemeen-omschrijving", ui.item.value);
      },
      open: function (e, ui) {
        $(".ui-autocomplete").css(
          "top",
          $("ul.ui-autocomplete").cssUnit("top")[0] + 2
        );
      },
    });

    $("#algemeen-naam").on("input", function () {
      // that.algemeenNaam.length = 0;
      that.searchFilterColumns($(this).val(), this.id);
      // get the current value of the input field.
    });
    $("#algemeen-code").on("input", function () {
      // that.algemeenCode.length = 0;
      that.searchFilterColumns($(this).val(), this.id);
      // get the current value of the input field.
    });
    $("#algemeen-status").on("input", function () {
      // that.algemeenStatus.length = 0;
      that.searchFilterColumns($(this).val(), this.id);
      // get the current value of the input field.
    });

    $("#algemeen-omschrijving").on("input", function () {
      // that.algemeenOmschrijving.length = 0;
      that.searchFilterColumns($(this).val(), this.id);
      // get the current value of the input field.
    });
    //#endregion

    function GetActionsOfRow(rowIds) {
      omnimap
        .GetActionsOfRowAction(rowIds, window.$catalog_management_units_token)
        .then(CallBackFunctions.GetActionsOfRowCallback)
        .catch((error) => {
          console.log(error);
        });
    }

    $(document).on("click", "#work-plans-koppel-aan-folder", () => {
      $("#cover-spin").show(0);

      var model = {
        action: "ADD",
        contextRol: "Werkplan zit in folder",
        folder: document.getElementById("tree-parent-id").value,
      };
      GC.StartActivity(
        model,
        window.$catalog_planning_period_selectedIds,
        "8c5da794-f8da-4549-9b48-f7123c59642a",
        koppelAanFolderCallBack(),
        window.$catalog_management_units_token
      );
    });

    function koppelAanFolderCallBack() {
      GC.sleep(2000).then(() => {
        $("#cover-spin").hide(0);
        $("#modal_koppel_aan_folder").modal("hide");
        that.reloadData(1);
      });
    }

    $(document).on("click", "#work_plans_map_aanmaken", function () {
      $("#mappen_folder_add_modal").modal("show");
    });

    $(document).on("click", "#werkplann_toevoegen", function () {
      $("#werkplannen_toevoegen_modal").modal("show");
    });
    $(document).on("click", "#work-plans-verwijderen", function () {
      if (window.$catalog_planning_period_selectedIds == 0) {
        alert("rows not selected");
      } else {
        $("#work-plans-mappen_beheren_delete_modal").modal("show");
      }
    });

    function handleRefresh () {
      $("#cover-spin").show(0);
      // $("#spinner").removeAttr("hidden");

      that.fillTable(window.$catalog_planning_period_lastUsedTableFilter, 1);

      // that.reloadData(1);
    }

    window.$catalog_planning_refresh = handleRefresh;
    $(".refresh").click(handleRefresh);

    $(".back-page-link").click(function () {
      $("#tableSide").removeClass("d-none");
      $("#detailSide").addClass("d-none");
      $("#editSide").addClass("d-none");
    });
    $("#edit-button").click(function () {
      $("#editSide").removeClass("d-none");
      $("#detailSide").addClass("d-none");
    });
    $("#return-detail").click(function () {
      $("#detailSide").removeClass("d-none");
      $("#editSide").addClass("d-none");
    });

    $("div.popup").click(function () {
      var selectedIds = [];
      $("#example")
        .dataTable()
        .$("tr.selected")
        .each(function () {
          selectedIds.push($(this).attr("rowId"));
        });
      that.setState({ selectedIds: selectedIds });

      window.$catalog_planning_period_selectedIds = selectedIds;

      GetActionsOfRow(selectedIds.join(","));
    });

    $(document).on("click", "#mappen_beheren", function () {
      $("#mappen_beheren_modal").modal("show");
    });
  }

  render() {
    return (
      <div id="tableSide">
        <table id="example" className="table-hover table min-full-width">
          <thead>
            <tr>
              {this.state.columnList}
              {/* <th className="sorting_disabled">
                <span className="checkAll" />
                <span className="checkNone" style={{ display: "none" }} />
              </th>
              <th className="sorting_disabled">
                <img
                  className="icon-table"
                  src={maatregelenSvg}
                  width={18}
                  height={18}
                />
              </th>
              <th>Naam</th>
              <th>Code</th>
              <th>Omschrijving</th>
              <th>Startdatum</th>
              <th>Einddatum</th>
              <th>Flexibel inplannen</th>
              <th>Datum aangemaakt</th>
              <th>Datum laatst gewijzigd</th> */}
            </tr>
          </thead>
          <tbody></tbody>
        </table>
        <input id="tree-parent-id" hidden />
        <input id="tree-parent-name" hidden />
      </div>
    );
  }
}

export default Table;
